import type {
  PreferenceInput,
  SupportedLocale,
} from '@brightdrop/localization-core';

/**
 * The preferences handed to the localization core, with a console language applied
 *
 * Under an override only the locale and the account's time zone are passed, so the core answers
 * units, date style, clock, week start and currency from that locale's regional defaults, as it
 * would for a reader of that market. Without one the input is returned as it is.
 *
 * @param preferences - The `/me` preference blocks
 * @param override - The console language, or null when none applies
 * @returns The preferences for `LocalizationGate`
 */
export const buildLocalizationPreferences = (
  preferences: PreferenceInput,
  override: SupportedLocale | null
): PreferenceInput =>
  override
    ? {
        userPreferences: {
          locale: override,
          timeZone: preferences?.userPreferences?.timeZone,
        },
        effectiveUserPreferences: {
          timeZone: preferences?.effectiveUserPreferences?.timeZone,
        },
      }
    : preferences;
